import React, { PropsWithChildren } from 'react';
import { Box, Grid, Tooltip } from '@material-ui/core';
import { IActivePlan } from '../interfaces/IActivePlan';
import Button from '../../../components/button/Button';
import moment from 'moment';
import CurrentPlanItem from './CurrentPlanItem';
import colors from '../../../styles/colors';

interface CurrentPlanProps {
  plan: IActivePlan | undefined;
  handleCancel(): void;
}

const CurrentPlan = (props: PropsWithChildren<CurrentPlanProps>) => {
  const { plan, handleCancel } = props;
  if (!plan) {
    return <span>loading plan</span>;
  }
  return (
    <Grid container>
      <Grid item xs={12} md={6}>
        <CurrentPlanItem showRenewal={true} plan={plan} />
      </Grid>
      <Grid item xs={12} md={6}>
        <Box
          display={'flex'}
          justifyContent={'center'}
          height={'100%'}
          alignItems={'flex-end'}
        >
          <Tooltip
            title={
              plan.cancelAtPeriodEnd
                ? `Your subscription will automatically cancel at the end of the subscription cycle on ${moment(
                    plan.renewalDate
                  ).format('MMMM Do, YYYY')}`
                : ''
            }
          >
            <div>
              <Button
                disabled={plan.cancelAtPeriodEnd}
                onClick={handleCancel}
                style={{
                  backgroundColor: colors.red,
                  padding: 'inherit 1rem',
                  color: 'white'
                }}
              >
                Cancel Auto-renewal
              </Button>
            </div>
          </Tooltip>
        </Box>
      </Grid>
    </Grid>
  );
};

export default CurrentPlan;
